import { DownloadsDailyConfirm, DownloadsDailyConfirms, DownloadsMonthlyStatement, DownloadsMonthlyStatements, DownloadsTaxDocument, DownloadsTaxDocuments, } from '..';
import dayjs from 'dayjs';
const RequestHeaders = {
    headers: { Accept: 'application/json' },
};
export function Downloads(api) {
    return {
        getDailyConfirms: (accountId, startDate, endDate) => {
            const startDateString = dayjs(startDate).format('YYYY-MM-DD');
            const endDateString = dayjs(endDate).format('YYYY-MM-DD');
            return api.authenticated().get(DownloadsDailyConfirms(accountId), {
                startDate: startDateString,
                endDate: endDateString,
            }, RequestHeaders);
        },
        getDailyConfirm: (accountId, date) => {
            const requestedDate = dayjs(date).format('YYYY-MM-DD');
            return api.authenticated().getBinary(DownloadsDailyConfirm(accountId), {
                date: requestedDate,
            }, RequestHeaders);
        },
        getMonthlyStatements: (accountId, startDate, endDate) => {
            const startDateString = dayjs(startDate).format('YYYY-MM-DD');
            const endDateString = dayjs(endDate).format('YYYY-MM-DD');
            return api.authenticated().get(DownloadsMonthlyStatements(accountId), {
                startDate: startDateString,
                endDate: endDateString,
            }, RequestHeaders);
        },
        getMonthlyStatement: (accountId, date) => {
            const requestedDate = dayjs(date).format('YYYY-MM-DD');
            return api.authenticated().getBinary(DownloadsMonthlyStatement(accountId), {
                date: requestedDate,
            }, RequestHeaders);
        },
        getTaxDocuments: (accountId, form, taxYear) => {
            return api.authenticated().get(DownloadsTaxDocuments(accountId, form), {
                taxYear: taxYear
            }, RequestHeaders);
        },
        getTaxDocument: (accountId, form, date) => {
            const requestedDate = dayjs(date).format('YYYY-MM-DD');
            return api.authenticated().getBinary(DownloadsTaxDocument(accountId, form), {
                date: requestedDate,
            }, RequestHeaders);
        },
    };
}
//# sourceMappingURL=downloads.js.map